var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { EnumIframeMessageTypes } from '../models/EnumIframeMessageTypes';
export var SS_HURDLE_BOOST_PROPS = {
  HINT_NAME: 'hurdle_boost_clue',
  SENT_EnterSecondInvalidTry: 'SS_HURDLE_SENT_EnterSecondInvalidTry',
  USED_hurdle_boost_clue: 'SS_HURDLE_USED_hurdle_boost_clue'
};
var GameObservable = /** @class */function () {
  function GameObservable() {
    this.fn = null;
    this.functions = [];
  }
  // Being called by game
  GameObservable.prototype.next = function (event) {
    var _a;
    if (this.fn) {
      (_a = this.fn) === null || _a === void 0 ? void 0 : _a.call(this, event);
    }
  };
  GameObservable.prototype.xSubscribe = function (fn) {
    this.fn = fn;
  };
  GameObservable.prototype.xUnsubscribe = function () {
    this.fn = null;
  };
  // Reserved - used by game
  GameObservable.prototype.subscribe = function (f) {
    this.functions.push(f);
  };
  GameObservable.prototype.dispatch = function (action, postMessageToIframe) {
    this.functions.forEach(function (f) {
      return f(action);
    });
    if (postMessageToIframe) {
      postMessageToIframe({
        type: EnumIframeMessageTypes.UPDATE_LOCAL_STORAGE,
        payload: __assign(__assign({}, JSON.parse(JSON.stringify(window.localStorage))), {
          passedCookiesData: "".concat(document.cookie)
        })
      });
      postMessageToIframe({
        type: EnumIframeMessageTypes.AUTH_API_EVENT,
        payload: __assign({}, action)
      });
    }
  };
  return GameObservable;
}();
export { GameObservable };